import React from 'react';

import ProgressHeader from '../../../../components/progress-header/progress-header';

import './fitment-crumbs.scss';

interface CrumbShape {
  isActive?: boolean;
  isCompleted?: boolean;
  label: string;
}

interface FitmentCrumbsProps {
  className?: string;
  crumbs: CrumbShape[];
  onCrumbSelected: (crumbLabel: string) => void;
  selectedCrumb?: string;
}

function FitmentCrumbs(props: FitmentCrumbsProps) {
  const { className = '', crumbs, onCrumbSelected, selectedCrumb } = props;

  const activeSection = selectedCrumb || crumbs[0].label;

  const headerItems = crumbs.map(crumb => ({
    isClickable: crumb.isActive,
    isCompleted: crumb?.isCompleted,
    section: crumb.label,
    title: [
      {
        value: crumb.label
      }
    ]
  }));

  const onStepClick = stepNumber => {
    const selectedCrumb = crumbs[stepNumber - 1].label;
    onCrumbSelected(selectedCrumb);
  };

  return (
    <div
      className={`${className} fitment-crumbs`}
      id="fitment-crumbs"
      styleName="container"
    >
      <ProgressHeader
        activeSection={activeSection}
        headerItems={headerItems}
        onStepClick={onStepClick}
      />
    </div>
  );
}

export default FitmentCrumbs;
